<template>
  <div></div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ShowValidationError',
  mounted () {
    if (!this.validationError) {
      return
    }
    const errMsg = this.validationError
    this.errorToast(errMsg)
    const data = {
      type: 'technical',
      message: errMsg.substring(0, 50),
      code: String(this.validationErrorCode)
    }
    if (typeof window.trackingNS?.track?.tracking === 'function') {
      window.trackingNS.track.tracking('error', data)
    }
    this.resetValidationError()
  },
  computed: {
    ...mapGetters('kwk', ['validationErrorCode', 'validationError'])
  },
  methods: {
    ...mapMutations('kwk', ['resetValidationError'])
  }
}
</script>
